<template>
  <v-container>
    <v-card class="elevation-3 mt-3">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex xs12>
            <v-toolbar color="white" text class="mt-0 pt-0 elevation-0">
              <v-toolbar-title class="subtitle-1 font-weight-medium">Editar Hospital</v-toolbar-title>
            </v-toolbar>
          </v-flex>

          <v-flex xs8>
            <v-card-text>
              <FormHospitalInfo 
                ref="formHospital" 
                :hospital="hospitalSelected"/>
            </v-card-text>
          </v-flex>


          <v-flex xs8>
            <v-card-text>
              <FormContactInfo
                ref="formContact" 
                :contact="hospitalSelected.contact"/>
            </v-card-text>
          </v-flex>
          <v-flex xs12 class="pl-12">
            <div v-if="errorEdit"></div>
            <v-btn
              class="body-2 white--text"
              @click="editHospital"
              color="primary"
              depressed
              :loading="loading"
            >
              Editar Hospital
            </v-btn>
          </v-flex>
          
        </v-layout>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import FormHospitalInfo from '../../../components/admin/hospital/FormHospitalInfo'
import FormContactInfo from '../../../components/admin/hospital/FormContactInfo'
import moment from 'moment'
export default {
  name: "NewHospital",
  props:['id'],
  components:{
    FormHospitalInfo,
    FormContactInfo
  },
  data: () => ({
      loading:false,
      errorEdit: undefined,
  }),
  computed: {
    formIsValid() {
      return (
        this.name &&
        this.email &&
        this.password &&
        this.cargo &&
        this.state &&
        this.telephone
      );
    },

    hospitalObj(){
      return this.$store.getters.hospitals[this.id]
    },

    hospitalSelected () {

      let selected = this.$store.getters.selectedHospital;
      return selected;
    },
  },
  mounted(){
      
  },
  watch: {
    //
  },
  methods: {

    async editHospital(){
        
        let formHospital = this.$refs.formHospital.setHospitalInfo()
        
        let formContact = this.$refs.formContact.setContactInfo()
        if(formContact && formHospital){
            this.loading = true
            let obj = {
                id: this.hospitalSelected.id,
                ...formHospital,
                contact: formContact,
                date: moment().format('DD/MM/YYYY')
            }
            console.log(obj)
            
            let dado = await this.$store.dispatch("editHospital", obj)
              .then( async ( response ) => {
                if (response.status){
                  await this.$store.dispatch('loadHospitals');
                  setTimeout( () => {
                    this.$router.back();
                  }, 400 );
                }else{
                  //TODO: houve erro, criar msg pro usuário de resposta

                }
                this.loading = false;
                
              })
              .catch(error=>{
                //TODO: houve erro, criar msg pro usuário de resposta
                this.loading = false
              })
        }
    }
  }
};
</script>

<style>
</style>